<template>
  <div class="redeem">
    <v-row
      class="fill-height"
      justify="center"
      align="center"
      no-gutters
    >
      <v-col cols="12" md="4">
        <div v-if="success">
          <v-card>
            <v-card-title><h1>Success</h1></v-card-title>
            <v-card-text>
              You have successfully redeemed the coupon code for Loud & Clear Speech Therapy. Please open your app and start your next exercises today :D
            </v-card-text>
          </v-card>
        </div>
        <v-form v-else ref="redeem">
          <v-card>
            <v-toolbar color="#002E4F" dark elevation="0">
              <v-toolbar-title>Redeem a Loud & Clear Subscription Coupon</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <p>Enter the email that you use to login to Loud & Clear and the coupon below</p>
              <v-text-field
                v-model="email"
                label="Email Address"
                :rules="[v => !!v || 'Field is required']"
              />
              <v-text-field
                v-model="code"
                label="Coupon Code"
                :rules="[v => !!v || 'Field is required']"
              />
              <div class="mb-2" />
              <v-btn block dark color="#002E4F" @click="redeem">Redeem Coupon</v-btn>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { reactive, toRefs, defineComponent, ref } from '@vue/composition-api';
import { ServiceFactory } from '@/service/ServiceFactory';

const CouponService = ServiceFactory.get('coupon');

export default defineComponent({
  name: 'Redeem',

  setup(props, { refs }) {
    const state = reactive({
      email: '',
      code: ''
    });

    const success = ref(false);

    /**
     * Redeem coupon
     * */
    async function redeem() {
      if (refs.redeem.validate()) {
        const payload = { ...state };
        console.debug(payload);
        try {
          await CouponService.activateByEmail(payload);
          success.value = true;
        } catch (e) {
          const message = e.response ? e.response.data.message : e.message;
          throw new Error(message);
        }
      }
    }

    return {
      ...toRefs(state),
      success,
      redeem
    };
  }
});
</script>

<style lang="scss">
.redeem {
  height: 100vh;
}
</style>
